import React, { useEffect, useState } from 'react';
import IconButtonWrapper from 'views/pages/manage/common/form-fields-mui/IconButtonWrapper';
import { ReactComponent as BackIcon } from "../../../../assets/img/svg/BackArrow.svg"
import { useLocation } from "react-router";
import ALoader from 'views/pages/manage/common/a-loader';
import ViewStudentRefundDetail from './ViewStudentRefundDetail';
import ProgressAndActionsWrapper from './ProgressAndActionsWrapper';
import { getDropdown, getLogs, getRefundDetail } from './utils';
import { getReceiptDetail } from 'views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/utils';
import { getStudentDetails } from 'views/pages/manage/unAssigned/collectPayment/apis';
import { fetchAllBatchesByApplicationId } from 'redux/studentSearch/actions';
import { getRefundReason } from '../utils';
import { fetchStudentSecurityCourseId } from 'modules/studentRefund/studentRefundRequest/multiTypeRefund/utils';

const ViewRefundApproval = () => {
    const [details, setDetails] = useState({})
    const [loader, setLoader] = useState(false)
    const [logs, setLogs] = useState();
    const [dropdownData, setDropdownData] = useState({});
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const psid = queryParams.get("psid");
    const refundNumber = queryParams.get("refundNumber");
    const applicationId = queryParams.get("applicationId");
    const refundFlow = queryParams.get("refundFlow");
    // const id = queryParams.get("id");


    const getDetails = async () => {
        setLoader(true);
        try {
            const res = await Promise.all([getRefundDetail(refundNumber), getLogs({ psid, refundNumber, applicationId }), fetchAllBatchesByApplicationId(applicationId), getRefundReason(), fetchStudentSecurityCourseId(applicationId)])
            const refundCompletion = res[0]?.refundDto?.completionRefundDetails ?? {}
            //   const refundRectification= res[0]?.refundDto?.??{}
            const refundDto = res[0]?.refundDto ?? {}
            const batchDetail = res[2]?.map((item) => item?.batchName)
            const data = { ...res[0], ...refundCompletion, ...refundDto, batch: batchDetail }
            // if applicationId and currentApplicationId is not null then only fetch student details
            const receiptData = await Promise.all([getStudentDetails(data?.applicationId), getStudentDetails(refundDto?.correctApplicationId)])
            const { oldReceiptTotalAmount, oldReceiptId, oldReceiptDate, desc, paymentMode, oldReceiptDesc, createdBy, refundReceiptMapping } = refundDto || {}
            const { subOrderType, refundAmount } = res[0];
            const negativeReceipts = refundReceiptMapping?.filter(item => item?.receiptType?.toLowerCase() == 'negative').map(item => ({
                ...item,
                paymentMode: subOrderType,
                receiptAmount: refundAmount,
                receiptDate: item?.createdOn,
                oldReceiptId: item?.negativeReceiptId,
                oldReceiptDate: item?.createdOn
            }));

            const positiveReceipts = refundReceiptMapping?.filter(item => item?.receiptType?.toLowerCase() == 'positive').map(item => ({
                ...item,
                paymentMode: subOrderType,
                receiptAmount: refundAmount,
                receiptDate: item?.createdOn,
                newReceiptDate: item?.createdOn,
                newReceiptId: item?.negativeReceiptId
            }));

            const viewDetail = {
                ...data,
                studentFatherName: receiptData[0]?.data?.studentApplicationDetailsSearchResponseDTOList?.[0]?.studentFatherName,
                sdCourseId: res[4],
                oldReceiptList: [{ oldReceiptTotalAmount, oldReceiptId, oldReceiptDate, refundAmount: res[0]?.refundAmount, desc, paymentMode, oldReceiptDesc, createdBy }],
                stream: receiptData[0]?.data?.studentApplicationDetailsSearchResponseDTOList?.[0]?.academicGroupValue,
                career: receiptData[0]?.data?.studentApplicationDetailsSearchResponseDTOList?.[0]?.academicCareerValue,
                cashierOffice: receiptData[0]?.data?.studentApplicationDetailsSearchResponseDTOList?.[0]?.cashierOffice,
                logs: res[1]?.paginatedData,
                rectificationReason: (res[3]?.find(item => item?.value == data?.orderReasonId))?.label,
                newStudentName: receiptData[1]?.data?.studentApplicationDetailsSearchResponseDTOList?.[0]?.studentName,
                newTermValue: receiptData[1]?.data?.studentApplicationDetailsSearchResponseDTOList?.[0]?.term?.dispValue,
                newRegularCourseId: receiptData[1]?.data?.studentApplicationDetailsSearchResponseDTOList?.[0]?.courseId,
                newBusinessAreaValue: receiptData[1]?.data?.studentApplicationDetailsSearchResponseDTOList?.[0]?.businessAreaDispVal,
                negativeReceipts: negativeReceipts,
                positiveReceipts: positiveReceipts
            }
            setDetails(viewDetail)
            setLogs(res?.[1]?.paginatedData ?? [])
        }
        catch (err) {
            console.error(err)
        }
        finally {
            setLoader(false)
        }
    }
    const getDropdownData = async () => {
        const dropdowns = await getDropdown();
        setDropdownData(dropdowns);
    }
    const init = async () => {
        getDropdownData()
        getDetails()

    }
    useEffect(() => {
        init()
    }, [])


    return (
        <>
            {loader && <ALoader position='fixed' />}
            <div className="large-text mx-5 my-4 label-color">
                <IconButtonWrapper onClick={() => window.close()}>
                    <BackIcon />
                </IconButtonWrapper>
                {/* {`${details?.studentName} (${psid})`} */}
                Student Refund Details
            </div>
            <div className="mx-5 d-flex justify-space-between">
                <div style={{ width: "65%" }}>
                    <ViewStudentRefundDetail dropdownData={dropdownData} refundFlow={refundFlow} details={details} logs={logs} setLoader={setLoader} />
                </div>
                <div className="flex-grow-1">
                    <ProgressAndActionsWrapper refundFlow={refundFlow} getDetails={getDetails} psid={psid} details={details} logs={logs} setLoader={setLoader} applicationId={applicationId} id={refundNumber} dropdownData={dropdownData} />
                </div>
            </div>

        </>
    )
}
export default ViewRefundApproval